import React, { useEffect, useState } from "react";
import FilterSelect from "component/common/FilterSelect";
import Search from "component/common/TableFilter/Search";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router";
import { debounce } from "debounce";
import { getInventoryDropdown, getDonationDropdown } from "service/Common";
import { Toast } from "utils/toast";

import styles from "./TransactionFilter.module.scss";

const TransactionFilter = () => {
  const location = useLocation();

  const history = useHistory();

  let [filter, setFilter] = useState({
    code: undefined,
    product: undefined,
    buyer: undefined,
    seller: undefined,
    received: undefined,
    profit: undefined,
    paid: undefined,
    type: undefined,
  });

  const typeOptions = ["All", "sale", "donation"];

  const sortOptions = ["Sort By", "Low to High", "High to Low"];

  useEffect(() => {
    let query = queryString.parse(location.search);
    let data = {
      ...filter,
      profit:
        query.profit != undefined
          ? query.profit == "1"
            ? "Low to High"
            : "High to Low"
          : undefined,
      received:
        query.received != undefined
          ? query.received == "1"
            ? "Low to High"
            : "High to Low"
          : undefined,
      paid:
        query.paid != undefined
          ? query.paid == "1"
            ? "Low to High"
            : "High to Low"
          : undefined,
      type: query.type == "All" ? undefined : query.type,
      seller: query.seller == "" ? undefined : query.seller,
      code: query.code == "" ? undefined : query.code,
      product: query.product == "" ? undefined : query.product,
      buyer: query.buyer == "" ? undefined : query.buyer,
    };
    setFilter(data);
  }, [location.search]);

  const handleChange = (event) => {
    let data = { ...filter, [event.name]: event.value };
    let params = {
      code: data.code == "" ? undefined : data.code,
      product: data.product == "" ? undefined : data.product,
      seller: data.seller == "" ? undefined : data.seller,
      buyer: data.buyer == "" ? undefined : data.buyer,
      type: data.type == "All" ? undefined : data.type,
      received:
        data.received == "Low to High"
          ? "1"
          : data.received == "High to Low"
          ? "2"
          : undefined,
      paid:
        data.paid == "Low to High"
          ? "1"
          : data.paid == "High to Low"
          ? "2"
          : undefined,
      profit:
        data.profit == "Low to High"
          ? "1"
          : data.profit == "High to Low"
          ? "2"
          : undefined,
    };
    setFilter(data);
    if (queryString.stringify(params).length == 0) {
      history.push(`/admin/transactions/list`);
    } else {
      history.push(`/admin/transactions/list?${queryString.stringify(params)}`);
    }
  };

  return (
    <tr className={styles.transaction_filter}>
      <td>
        <Search
          name="code"
          onChange={debounce(handleChange, 500)}
          value={filter.code ? filter.code : ""}
        />
      </td>
      <td>
        <Search
          name="product"
          onChange={debounce(handleChange, 500)}
          value={filter.product ? filter.product : ""}
        />
      </td>
      <td>
        <Search
          name="buyer"
          onChange={debounce(handleChange, 500)}
          value={filter.buyer ? filter.buyer : ""}
        />
      </td>
      <td>
        <FilterSelect
          options={sortOptions}
          placeholder="Sort By"
          isSort={true}
          name="received"
          value={filter.received ? filter.received : "Sort By"}
          onChange={handleChange}
        />
      </td>
      <td></td>
      <td>
        <Search
          name="seller"
          onChange={debounce(handleChange, 500)}
          value={filter.seller ? filter.seller : ""}
        />
      </td>
      <td>
        <FilterSelect
          options={sortOptions}
          placeholder="Sort By"
          isSort={true}
          name="paid"
          value={filter.paid ? filter.paid : "Sort By"}
          onChange={handleChange}
        />
      </td>
      <td>
        <FilterSelect
          options={sortOptions}
          placeholder="Sort By"
          isSort={true}
          name="profit"
          value={filter.profit ? filter.profit : "Sort By"}
          onChange={handleChange}
        />
      </td>
      <td>
        <FilterSelect
          options={typeOptions}
          name="type"
          value={filter.status ? filter.status : "All"}
          onChange={handleChange}
        />
      </td>
      <td></td>
    </tr>
  );
};

export default TransactionFilter;
